//
//
//
//

import { mapGetters, mapState } from 'vuex';
import { updateColours, updateFavicon, updateTitle } from '@/helpers/page';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS, SETTINGS } from '@/store/types/namespaces';

export default {
  name: 'App',
  computed: {
    ...mapState(SETTINGS, ['title', 'favicon']),
    ...mapGetters(COLOURS, [PALETTE_COLOURS]),
  },
  watch: {
    title() {
      updateTitle(this.$route);
    },
    favicon() {
      updateFavicon();
    },
    [PALETTE_COLOURS]() {
      updateColours();
    },
  },
  mounted() {
    updateFavicon();
    updateColours();
  },
};
